export default [
  {
    path: "clientes",
    name: "clients",
    redirect: { name: "clients-list" },
    children: [
      {
        path: "",
        name: "clients-list",
        component: () => import("@/modules/clients/views/ClientsList.vue"),
      },
      {
        path: "ver/:id",
        redirect: "clients-show",
        children: [
          {
            path: "",
            name: "clients-show",
            component: () => import("@/modules/clients/views/ClientsShow.vue"),
          },
          {
            path: "movimientos",
            name: "clients-show-movements",
            component: () =>
              import("@/modules/clients/views/ClientMovements.vue"),
          },
        ],
      },
    ],
  },
];
